import { useContext, useEffect, useState } from "react"
import { FilterContext } from "../../contexts/FilterContext"
import useFilterField from "../../../../hooks/useFilterField"
import useFilterInit from "../useFilterInit"
import { api } from "../../../../services/api"
import { GlobalAlertContext } from "../../../../contexts/GlobalAlertContext"

export default function useModalReport() {

    const { resumo, devedor, contrato, motivo, estagio, saldo, valor_original, groupsSelected } = useContext(FilterContext)
    const { handleToast, handleLoading } = useContext(GlobalAlertContext);
    const { handleFilter } = useFilterField()
    const { handleInit } = useFilterInit()

    const dados = resumo?.map((el, i) => {
        return {
            ...el,
            id: i,
        }
    })
    
    const [result, setResult] = useState([]);
    const [amount, setAmount] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    const [offset, setOffset] = useState(0);
    const [page, setPage] = useState(0);

    console.log({result});

    const [newFilter, setNewFilter] = useState('0')

    const refresh = async (page, size = pageSize) => {
        // setPage(page / size)
        const objFilter = {
            motivo: filter.motivo.value.map(value => { return value.label }).join('||'),
            estagio: filter.id_estagio.value.join('||'),
            contrato: filter.contrato.value.map(value => { return value.label }).join('||'),
            devedor: filter.devedor.value.map(value => { return value.label }).join('||'),
            data_entrada: filter.data_entrada.value.join('||'),
            data_acordo: filter.data_acordo.value.join('||'),
            vencimento: filter.vencimento.value.join('||'),
            data_finalizacao: filter.data_finalizacao.value.join('||'),
            valor_original: filter.valor_original.value.join('||'),
            saldo: filter.saldo.value.join('||')
        }

        const urlFilter = new URLSearchParams(objFilter).toString();
        setNewFilter(urlFilter)
        const returnedValues = await fetchResult(page, groupsSelected, urlFilter, size);
        setAmount(returnedValues.count);
        setResult(returnedValues.results);
    };

    const handlePageSize = async (newPage) => {
        handleLoading(true)
        setPage(newPage);
        await refresh(newPage * pageSize);
        handleLoading(false)
    };

    const fetchResult = async (page, id_client, filter, size = pageSize) => {
        const ids = id_client.map(el => {
            return el.id
        })
        const { data: response } = await api({ method: "GET", url: "/source/analitico/" + ids.join(",") + "?page=" + page + "&pageSize=" + size + '&' + filter });
        const returnedValues = {
            results: response.results,
            count: response.count
        };
        return returnedValues;
    };

    const [filter, setFilter] = useState({})

    const [selection, setSelection] = useState({ select: [], init: true })
    const [data, setData] = useState([])


    const handleValue = ({ field, value }) => {
        setFilter(obj => {
            obj[field].value = value
            // Object.keys(obj).map(key => {
            //     if (key === field) {
            //     }
            // })
            return { ...obj }
        })
        refresh(0)
    }


    function compareMin(a, b) {
        return Number(a.label) - Number(b.label);
    }
    function compareMax(a, b) {
        return Number(b.label) - Number(a.label);
    }

    useEffect(() => {
        let newData = [...dados]
        Object.keys(filter).map(row => {

            if (!!filter[row]?.value?.length && (row !== "data_acordo" && row !== "data_finalizacao" && row !== "data_entrada" && row !== "vencimento" && row !== "id_estagio" && row !== "valor_original" && row !== "saldo")) {
                let arr = []
                filter[row].value.map(el => {
                    const newArr = handleFilter({ list: newData, value: el.label, column: row })
                    arr = [...arr, ...newArr]
                })
                newData = arr
            } else if (!!filter[row].value.length && row === "id_estagio") {
                let arr = []
                filter[row].value.map(el => {
                    const newArr = handleFilter({ list: newData, value: el, column: row })
                    arr = [...arr, ...newArr]
                })
                newData = arr
            } else if (!!filter[row].value.length && row === "data_acordo" || row === "data_finalizacao" || row === "data_entrada" || row === "vencimento") {
                let arr = []
                if (!!filter[row]?.value[0] && !!filter[row]?.value[1]) {
                    const newArr = newData.filter(data => new Date(data[row]).setHours(0, 0, 0, 0) >= new Date(filter[row]?.value[0]).setHours(0, 0, 0, 0) && new Date(data[row]).setHours(0, 0, 0, 0) <= new Date(filter[row]?.value[1]).setHours(0, 0, 0, 0))
                    arr = [...arr, ...newArr]
                    newData = arr
                } else if (!!filter[row]?.value[0]) {
                    const newArr = newData.filter(data => new Date(data[row]).setHours(0, 0, 0, 0) >= new Date(filter[row]?.value[0]).setHours(0, 0, 0, 0))
                    arr = [...arr, ...newArr]
                    newData = arr
                } else if (!!filter[row]?.value[1]) {
                    const newArr = newData.filter(data => new Date(data[row]).setHours(0, 0, 0, 0) <= new Date(filter[row]?.value[1]).setHours(0, 0, 0, 0))
                    arr = [...arr, ...newArr]
                    newData = arr
                }
            } else if (!!filter[row].value.length && row === "valor_original" || row === "saldo") {

                if (!!filter[row]?.value[0] && !!filter[row]?.value[1]) {
                    const newArr = newData.filter(data => data[row] >= filter[row]?.value[0] && data[row] <= filter[row]?.value[1])
                    newData = newArr
                }
            }
        })
        newData = newData.map((el, index) => {
            return {
                ...el,
                id: index
            }
        });
        setData([...newData]);
        return () => {
      
        }
    }, [filter])

    useEffect(() => {
        const listSelectFilter = {
            devedor: { options: [], value: [] },
            contrato: { options: [], value: [] },
            motivo: { options: [], value: [] },
            id_estagio: { options: [], value: [] },
            data_acordo: { options: [], value: [null, null] },
            data_finalizacao: { options: [], value: [null, null] },
            data_entrada: { options: [], value: [null, null] },
            vencimento: { options: [], value: [null, null] },
            valor_original: { options: [], value: [] },
            saldo: { options: [], value: [] }
        }
        devedor.map((el, index) => {
            listSelectFilter.devedor.options.push({ label: el.devedor, id: index })
        })
        contrato.map((el, index) => {
            listSelectFilter.contrato.options.push({ label: el.contrato, id: index })
        })
        motivo.map((el, index) => {
            listSelectFilter.motivo.options.push({ label: el.motivo, id: index })
        })
        estagio.map((el, index) => {
            listSelectFilter.id_estagio.options.push({ label: el.id_estagio, id: index })
        })
        valor_original.map((el, index) => {
            listSelectFilter.valor_original.options.push({ label: el.valor_original, id: index })
        })
        saldo.map((el, index) => {
            listSelectFilter.saldo.options.push({ label: el.saldo, id: index })
        })
        setFilter(listSelectFilter)
        setData(dados)
        return () => {
      
        }
    }, [resumo])

    const handleButton = ({ key }) => {
        const value = handleInit({ key })
        setFilter(obj => {
            obj.id_estagio.value = value
            if (value.find(val => val.toUpperCase() == "Finalizado".toUpperCase())) {
                const value = obj.motivo?.options.find(opt => opt.label.includes(key))
                if (!!value) {
                    obj.motivo.value = [value]
                }
            }
            return { ...obj }
        })
    }

    const cleanValues = () => {
        setFilter(obj => {
            Object.keys(obj).map(key => {
                obj[key].value = []
                if (key === "data_acordo" || key === "data_finalizacao" || key === "data_entrada" || key === "vencimento") {
                    obj[key].value = [null, null]
                }
            })
            return { ...obj }
        }
        )
    }

    return {
        filter,
        data,
        handleValue,
        compareMin,
        compareMax,
        handleButton,
        cleanValues,
        selection,
        setSelection,
        refresh,
        handlePageSize,
        result,
        amount,
        newFilter,
        page,
        setPageSize,
        pageSize
    }
}